const $ = require('jquery');
const angular = require('angular');
require('dotdotdot');
const pdpLinkClickMapper = require('../product/atm-mapper-pdp-link-click');

module.exports = function ($timeout, moveFocus, decorateAdditionalDetails, searchService, atm) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            products: '='
        },
        link(scope) {
            scope.isCollapsed = true;
            scope.productsInSameOffer = searchService.transformProductsToDefault(scope.products.Items, true);
            decorateAdditionalDetails(scope.productsInSameOffer);

            scope.truncate = function () {
                $timeout(function () {
                    $(angular.element.find('.js-truncate')).dotdotdot();
                }, 300, false);
            };

            scope.moveFocus = function () {
                moveFocus('.js-related-prod-ex-content .related-product:first-child');
            };

            scope.handleViewAllInOfferClick = function () {
                atm.push({
                    linkName: `web:pdp:recommended products on offer:view all in offer`,
                    linkType: 'pdp recommended products on offer'
                }, pdpLinkClickMapper);
            };

            scope.handleViewMoreLessClick = function () {
                this.isCollapsed = !this.isCollapsed;
                atm.push({
                    linkName: `web:pdp:recommended products on offer:view ${this.isCollapsed ? 'less-' : 'more+'}`,
                    linkType: 'pdp recommended products on offer'
                }, pdpLinkClickMapper);
            };

            function init() {
                scope.truncate();
            }

            init();
        },
        template: require('./related-products-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/relatedproducts/related-products-directive.js
 **/